import { render } from "./MagentoSupportSecurity.vue?vue&type=template&id=56c0aa84"
import script from "./MagentoSupportSecurity.vue?vue&type=script&lang=js"
export * from "./MagentoSupportSecurity.vue?vue&type=script&lang=js"

import "./MagentoSupportSecurity.vue?vue&type=style&index=0&id=56c0aa84&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__